import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  actFilter: {
    padding: '1.5rem 0 1rem 0',
  },
  activeBox: {
    alignItems: 'center',
    backgroundColor: '#E8932E !important',
    borderRadius: '7px',
    color: '#FFFFFF',
    cursor: 'pointer',
    display: 'flex',
    height: '43px',
    justifyContent: 'center',
    letterSpacing: '0.93px',
    opacity: '1 !important',
    width: '85px',
  },
  asend: {
    alignItems: 'center',
    color: '#979598 !important',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '0.75rem !important ',
    paddingRight: '1rem',
  },
  borderBottom: {
    borderBottom: '1px solid #403849',
    marginBottom: '1rem !important',
  },
  cardHeading: {
    alignItems: 'center',
    display: 'flex',
    paddingRight: '12px',
  },
  cardMainHeading: {
    alignSelf: 'center',
    color: '#241A2E !important',
    fontFamily: 'FiraSans-Bold !important',
    fontSize: '1.125rem !important',
    padding: '14px',
  },
  close: {
    color: '#D1D1D1 !important',
    fontSize: '0.875rem !important',
    marginLeft: '0.3rem !important',
  },
  dFlexA: {
    alignItems: 'center',
    display: 'flex',
  },
  dFlexJA: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  dayBox: {
    alignItems: 'center',
    backgroundColor: '#403849',
    borderRadius: '7px',
    color: '#FFFFFF',
    cursor: 'pointer',
    display: 'flex',
    height: '43px',
    justifyContent: 'center',
    letterSpacing: '0.93px',
    opacity: '0.43',
    width: '85px',
  },
  fIcon: {
    alignItems: 'center',
    border: '2px solid #E7E7E7',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    height: '40px',
    justifyContent: 'center',
    width: '40px',
  },
  filteIcon: {
    width: '18px',
  },
  filterBtn: {
    alignItems: 'center',
    backgroundColor: '#DEC330',
    borderRadius: '4px',
    color: '#fff !important',
    cursor: 'pointer',
    display: 'flex',
    height: '48px',
    justifyContent: 'center',
    textTransform: 'uppercase',
    width: '100%',
  },
  filterItem: {
    alignItems: 'center',
    backgroundColor: '#E8E8E8',
    borderRadius: '24px',
    color: '#979598 !important',
    cursor: 'pointer !important',
    display: 'flex',
    fontSize: '0.875rem !important',
    height: '34px',
    justifyContent: 'space-between',
    margin: '0 0.5rem 0.5rem 0!important',
    minWidth: '72px',
    padding: '0 0.7rem',
  },
  filterList: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0 1rem',
    width: '100%',
  },
  filterText: {
    color: '#979598 !important',
    cursor: 'pointer !important',
    fontSize: '0.875rem !important',
  },
  fimg: {
    width: '28px',
  },
  hIcon: {
    cursor: 'pointer',
    paddingRight: '0.5rem',
  },
  inputF: {
    '&::placeholder': {
      color: '#FFFFFF',
      fontFamily: 'FiraSans-Medium',
      opacity: '0.43',
    },
    '&:focusVisible': {
      outline: 'unset !important',
    },
    background: 'unset !important',
    border: 'unset !important',
    color: '#ffff !important',
    width: '100%',
  },
  loader: {
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    minHeight: 'calc(100vh - 200px)',
  },
  padcss: {
    paddingLeft: '0px !important',
    paddingTop: '0px !important',
  },
  resetF: {
    alignItems: 'center',
    color: '#777777 !important',
    cursor: 'pointer',
    display: 'flex',
    fontFamily: 'FiraSans-Bold',
    fontSize: '0.75rem !important',
    justifyContent: 'center !important',
    letterSpacing: '0.8px',
    textDecoration: 'underline solid #777777',
  },
  searchBox: {
    alignItems: 'center',
    backgroundColor: '#403849',
    borderRadius: '7px',
    display: 'flex',
    height: '43px',
    marginBottom: '1rem !important',
  },
  tabPanel: {
    [theme.breakpoints.down('md')]: {
      maxHeight: '100%',
    },
    maxHeight: 'calc(100vh - 205px)',
    minHeight: '43vh',
    overflowY: 'auto',
    padding: '2rem 4rem 2rem 4rem !important',
  },
  tabPanelForDOT: {
    [theme.breakpoints.down('md')]: {
      maxHeight: '100%',
    },
    maxHeight: 'calc(100vh - 205px)',
    minHeight: '43vh',
    overflowY: 'auto',
    padding: '2rem 0 2rem 4rem !important',
  },
}));
export default useStyles;
